var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailOtherthreadDownNormal = function SvgNewcsDashboardCrashanalysisIssuedetailOtherthreadDownNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_otherthread_down_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M757 276h12v12h-12z",
    "data-name": "\\u77E9\\u5F62 380"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_otherthread_down_normal_svg__a)",
    transform: "translate(-757 -276)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M757 282a6 6 0 0 1 6-6 6 6 0 0 1 6 6 6 6 0 0 1-6 6 6 6 0 0 1-6-6m1 0a5.005 5.005 0 0 0 5 5 5.006 5.006 0 0 0 5-5 5.006 5.006 0 0 0-5-5 5.005 5.005 0 0 0-5 5m4.646 1.751-2.388-2.388a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0L763 282.69l2.034-2.034a.5.5 0 0 1 .707 0 .5.5 0 0 1 0 .707l-2.388 2.388a.5.5 0 0 1-.354.147.5.5 0 0 1-.353-.147",
    "data-name": "\\u8054\\u5408 33"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailOtherthreadDownNormal;